import * as React from "react";
import { useDispatch } from "react-redux";
import { messageSW } from "workbox-window";
import { offlineActions } from "configs";
import { dbQueries } from "duck";
import { Fragments } from "requests";
import { register } from "serviceWorkerRegistration";
import useToast from "../useToast";
import { Prompt } from "./components";

const useInitializeOfflineMode = () => {
  const dispatch = useDispatch();
  const toast = useToast();

  return (userData: Fragments.ApplicationSettingsUser) => {
    register({
      onUpdate: async (registration: ServiceWorkerRegistration) => {
        await registration.unregister();
        toast({
          duration: 10000,
          title: "A new version of DVM is available",
          description: React.createElement(Prompt, {
            onReload() {
              if (registration && registration.waiting) {
                messageSW(registration.waiting, {
                  type: "SKIP_WAITING"
                }).then(() => {});
                window.location.reload();
              }
            }
          })
        });
      },
      onInstalled: () => {
        dbQueries.saveUser(userData);
        dispatch(offlineActions.setSwStatus("installed"));
      }
    });
  };
};

export default useInitializeOfflineMode;
